import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isAll: false,
  selectedRows: []
}

export const multiSelectRowSlice = createSlice({
  name: 'multiSelectRow',
  initialState,
  reducers: {
    setSelectedRows: (state, action) => {
      state.isAll = action.payload.isAll
      state.selectedRows = action.payload.selectedRows ? action.payload.selectedRows : []
    }
  }
})

export const { setSelectedRows } = multiSelectRowSlice.actions

export const selectMultiSelectedRows = (state) => state.multiSelectRow

export default multiSelectRowSlice.reducer
